export default __webpack_public_path__ + "static/media/03_maliny_d-min.46310b77.jpg";